import { render, staticRenderFns } from "./TableAlunosRegulares.vue?vue&type=template&id=43dcab74&scoped=true"
import script from "./TableAlunosRegulares.vue?vue&type=script&lang=js"
export * from "./TableAlunosRegulares.vue?vue&type=script&lang=js"
import style0 from "./TableAlunosRegulares.vue?vue&type=style&index=0&id=43dcab74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dcab74",
  null
  
)

export default component.exports